import React from 'react'
import { func, bool, string, element } from 'prop-types'
import Captcha from '../Captcha'
import { Button, Form } from '@cobalt/cobalt-react-components'

class SecureForm extends React.Component {
  state = { recaptchaInstance: null }

  onRecaptchaRendered = recaptchaInstance =>
    this.setState({ recaptchaInstance })

  onExecuteRecaptcha = () => {
    const { recaptchaInstance } = this.state
    const { onExecuteRecaptcha } = this.props
    onExecuteRecaptcha()
    recaptchaInstance.execute()
  }

  render() {
    const {
      children,
      submitLabel,
      siteKey,
      disabledForm,
      onSubmit,
      isFormValid,
      isDanger
    } = this.props
    const isSubmitDisabled = disabledForm || !isFormValid

    return (
      <Form>
        {children}
        <Form.Field>
          <Captcha
            siteKey={siteKey}
            instance={this.state.recaptchaInstance}
            onRecaptchaRendered={this.onRecaptchaRendered}
            onSubmit={onSubmit}
          />
        </Form.Field>
        {isDanger ? (
          <Button
            type={Button.SUBMIT_TYPE}
            state={disabledForm ? Button.LOADING_STATE : null}
            disabled={isSubmitDisabled}
            onClick={this.onExecuteRecaptcha}
            danger
            fullWidth
          >
            {submitLabel}
          </Button>
        ) : (
          <Button
            type={Button.SUBMIT_TYPE}
            state={disabledForm ? Button.LOADING_STATE : null}
            disabled={isSubmitDisabled}
            onClick={this.onExecuteRecaptcha}
            primary
            fullWidth
          >
            {submitLabel}
          </Button>
        )}
      </Form>
    )
  }
}

SecureForm.propTypes = {
  onSubmit: func.isRequired,
  onExecuteRecaptcha: func.isRequired,
  siteKey: string.isRequired,
  isFormValid: bool.isRequired,
  disabledForm: bool.isRequired,
  submitLabel: string.isRequired,
  isDanger: bool,
  children: element
}

SecureForm.defaultProps = {
  isDanger: false
}

export default SecureForm
